import { declareVueComponent } from '/vodalys/vvuejs'

import VrunFormSas from './VrunFormSas.vue'

declareVueComponent('VrunFormSas', VrunFormSas)

const componentsMap = new Map()

export function getVueComponent(type) {
    console.log('getVueComponent', type);
    if (hasVueComponent(type)) {
        console.log(componentsMap.get(type));
        return componentsMap.get(type)
    }
}
export function hasVueComponent(type) {
    return componentsMap.has(type)
}

export function registerComponent(type, componentName, component) {
    componentsMap.set(type, component)
    declareVueComponent(componentName, component)
}